
import { getListOfRcsBotConfigs , addRcsBotConfig , updateRcsBotConfig , deleteRcsBotConfig} from "../types/account_rcs_bots_types";

export const getListOfRcsBotConfigsRequest = (data) => ({
    type: getListOfRcsBotConfigs.GET_LIST_OF_RCS_BOT_CONFIGS_REQUEST,
    payload: data,
});

export const getListOfRcsBotConfigsSuccess = (data) => ({
    type: getListOfRcsBotConfigs.GET_LIST_OF_RCS_BOT_CONFIGS_SUCCESS,
    payload: data
});

export const getListOfRcsBotConfigsFailure = (error) => ({
    type: getListOfRcsBotConfigs.GET_LIST_OF_RCS_BOT_CONFIGS_FAILURE,
    payload: error
});


// New bot config
export const addRcsBotConfigRequest = (data) => ({
    type: addRcsBotConfig.ADD_RCS_BOT_CONFIG_REQUEST,
    payload: data,
});

export const addRcsBotConfigSuccess = (data) => ({
    type: addRcsBotConfig.ADD_RCS_BOT_CONFIG_SUCCESS,
    payload: data
});

export const addRcsBotConfigFailure = (error) => ({
    type: addRcsBotConfig.ADD_RCS_BOT_CONFIG_ERROR,
    payload: error
});


//Edit bot

export const updateRcsBotConfigRequest = (payload, cb) => ({
    type: updateRcsBotConfig.UPDATE_RCS_BOT_CONFIG_REQUEST,
    payload,
    cb,
  });
  export const updateRcsBotConfigSuccess = (payload) => ({
    type: updateRcsBotConfig.UPDATE_RCS_BOT_CONFIG_SUCCESS,
    payload,
  });
  export const updateRcsBotConfigError = (payload) => ({
    type: updateRcsBotConfig.UPDATE_RCS_BOT_CONFIG_ERROR,
    payload,
  });

  // Delete Bot
  export const deleteRcsBotConfigRequest = (payload, cb) => ({
    type: deleteRcsBotConfig.DELETE_RCS_BOT_CONFIG_REQUEST,
    payload,
    cb,
  });
  export const deleteRcsBotConfigSuccess = (payload) => ({
    type: deleteRcsBotConfig.DELETE_RCS_BOT_CONFIG_SUCCESS,
    payload,
  });
  export const deleteRcsBotConfigError = (payload) => ({
    type: deleteRcsBotConfig.DELETE_RCS_BOT_CONFIG_ERROR,
    payload,
  });

